import { DISBALED_FUND_PAGES } from "../config";

export function isShareDisabled(isin: string) {
	return DISBALED_FUND_PAGES.indexOf(isin) >= 0;
}


// WEBPACK FOOTER //
// ./src/client/utils/disabled-shares.ts